import "@babel/polyfill";

import heroSection from './__modules/heroSection';
import mobileMenu from './__modules/mobileMenu';
import headerFill from './__modules/headerFill';
// import smoothScroll from './__modules/smoothScroll';
// import queryPosts from './__modules/queryPosts';
import getProjectData from './__modules/getProjectData';
import showProjectModal from './__modules/showProjectModal';
import projectsGrid from './__modules/projectsGrid';
import testimonialsSlider from './__modules/testimonialsSlider';
import equalHeightCat from './__modules/equalHeightCat';
import adjustments from './__modules/adjustments';
import openVideoModal from './__modules/openVideoModal';
import showItemsInit from './__modules/tabletInview';
import startAnimations from './__modules/animations';
// import serviceSelection from './__modules/serviceSelection';
import thankyouScroll from './__modules/thankyouScroll';
import subMenuWidth from './__modules/subMenuWidth';
import insights from './__modules/insights';
import fetchEvents, {fetchFutureEvents, fetchPastEvents} from './__modules/fetchEvents'

heroSection();

document.addEventListener('DOMContentLoaded', () => {
	openVideoModal();
	// queryPosts();
	mobileMenu();
	headerFill();
	//smoothScroll();
	testimonialsSlider();
	equalHeightCat();
	adjustments();
	showItemsInit();
	startAnimations();
	fetchEvents();
	thankyouScroll();
	//serviceSelection();
	//if (isWorkPage() || isHomePage()) {
		getProjectData();
		showProjectModal();
		projectsGrid();
	//}
	insights();
});

window.addEventListener('load', () => {
	subMenuWidth();
});

window.addEventListener('resize', () => {
	adjustments();
});

window.addEventListener('scroll', () => {
	showItemsInit();
});


function isWorkPage() {
	if (window.location.pathname == '/work.html' || window.location.pathname == '/work') {
		return true;		
	}
}
function isHomePage() {
	if (window.location.pathname == '/' || window.location.pathname == '/index.html') {
		return true;	
	}
}